/*
 * PDP Upsell-Slider Navigation (miiva)
 * Ersetzt die native Scrollbar ("Balken") des Upsell-Sliders durch dezente Pfeile
 * links/rechts (Meller-Stil). Ein Klick scrollt um genau eine Karte weiter.
 *
 * NUR Desktop (>= 900px). Mobil bleibt alles unveraendert (Swipe + Balken).
 * Das Markup wird nicht angefasst: der Slider wird zur Laufzeit in einen
 * position:relative-Wrapper gelegt, in dem die Pfeile absolut sitzen.
 */
(function () {
  var MQ = '(min-width: 900px)';
  var SLIDER_SEL = '.wt-product__upsell__slider';
  var CARD_SEL = '.wt-product__upsell__content';
  var WRAP_CLASS = 'wt-upsell-nav__wrap';

  var mq = window.matchMedia(MQ);

  function makeBtn(dir, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'wt-upsell-nav wt-upsell-nav--' + dir;
    b.setAttribute('aria-label', label);
    // Chevron; prev zeigt nach links, next nach rechts
    var pts = dir === 'prev' ? '15 5 8 12 15 19' : '9 5 16 12 9 19';
    b.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<polyline points="' + pts + '"/></svg>';
    return b;
  }

  function build() {
    var slider = document.querySelector(SLIDER_SEL);
    if (!slider) return;
    // schon gebaut?
    if (slider.parentNode && slider.parentNode.classList.contains(WRAP_CLASS)) return;

    var wrap = document.createElement('div');
    wrap.className = WRAP_CLASS;
    slider.parentNode.insertBefore(wrap, slider);
    wrap.appendChild(slider);

    var prev = makeBtn('prev', 'Vorherige Produkte');
    var next = makeBtn('next', 'Weitere Produkte');
    wrap.appendChild(prev);
    wrap.appendChild(next);

    // Scrollweite = Kartenbreite + Gap (faellt auf 80% der Sliderbreite zurueck)
    function step() {
      var card = slider.querySelector(CARD_SEL);
      if (!card) return slider.clientWidth * 0.8;
      var cs = window.getComputedStyle(slider);
      var gap = parseFloat(cs.columnGap || cs.gap) || 12;
      return card.getBoundingClientRect().width + gap;
    }

    prev.addEventListener('click', function () {
      slider.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      slider.scrollBy({ left: step(), behavior: 'smooth' });
    });

    // Am Anfang/Ende den jeweiligen Pfeil ausblenden -> dezent
    function update() {
      var max = slider.scrollWidth - slider.clientWidth;
      prev.classList.toggle('is-hidden', slider.scrollLeft <= 2);
      next.classList.toggle('is-hidden', max <= 2 || slider.scrollLeft >= max - 2);
    }

    /* Pfeil-Position messen:
     *  - vertikal: Mitte der BILDhoehe (nicht der ganzen Karte inkl. Text)
     *  - horizontal: Mitte zwischen Rand der Burgundy-Box und dem Produktbild
     * Werte gehen als CSS-Variablen an den Wrapper; die Pfeile zentrieren sich
     * darauf per translate(-50%, -50%).
     */
    function position() {
      var box = slider.closest('.wt-product__upsell');
      var card = slider.querySelector(CARD_SEL);
      if (!box || !card) return;

      var wrapRect = wrap.getBoundingClientRect();
      var boxRect = box.getBoundingClientRect();
      var sliderRect = slider.getBoundingClientRect();

      // vertikal: Mitte des Bildes
      var img = card.querySelector('.wt-product__upsell__picture, .wt-product__upsell__image');
      if (img) {
        var imgRect = img.getBoundingClientRect();
        if (imgRect.height > 0) {
          wrap.style.setProperty(
            '--upsell-arrow-top',
            imgRect.top - wrapRect.top + imgRect.height / 2 + 'px'
          );
        }
      }

      // horizontal: Mittelpunkte der Streifen Box-Rand <-> Slider-Kante,
      // jeweils als Abstand von der linken Wrapper-Kante
      wrap.style.setProperty(
        '--upsell-arrow-prev-x',
        (boxRect.left + sliderRect.left) / 2 - wrapRect.left + 'px'
      );
      wrap.style.setProperty(
        '--upsell-arrow-next-x',
        (boxRect.right + sliderRect.right) / 2 - wrapRect.left + 'px'
      );
    }

    function refresh() {
      update();
      position();
    }

    slider.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', refresh);
    refresh();
    // Bilder aendern Breite/Hoehe evtl. nachtraeglich -> nachmessen
    window.setTimeout(refresh, 300);
    var imgs = slider.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].complete) imgs[i].addEventListener('load', refresh, { once: true });
    }
  }

  function unbuild() {
    var wrap = document.querySelector('.' + WRAP_CLASS);
    if (!wrap) return;
    var slider = wrap.querySelector(SLIDER_SEL);
    if (slider) wrap.parentNode.insertBefore(slider, wrap);
    wrap.parentNode.removeChild(wrap);
  }

  function apply() {
    if (mq.matches) build();
    else unbuild();
  }

  function init() {
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
